import { useMemo } from 'react';
import { encode } from 'uqr';

/**
 * A QR code for a `upi://pay` link, drawn as one SVG path. Always dark on white with a quiet
 * zone: a phone camera reads contrast, not the till's theme. Medium error correction leaves room
 * for a scuffed screen or a glare spot without making the code too dense to read from a metre.
 */
export function UpiQr({ value, size = 208, label = 'UPI payment QR code' }: { value: string; size?: number; label?: string }) {
  const { path, modules } = useMemo(() => {
    const { data, size: count } = encode(value, { ecc: 'M', border: 0 });
    let d = '';
    data.forEach((row, y) => {
      row.forEach((on, x) => {
        if (on) d += `M${x} ${y}h1v1h-1z`;
      });
    });
    return { path: d, modules: count };
  }, [value]);

  return (
    <span className="qr-frame" data-testid="upi-qr">
      <svg
        role="img"
        aria-label={label}
        width={size}
        height={size}
        viewBox={`0 0 ${modules} ${modules}`}
        shapeRendering="crispEdges"
        style={{ display: 'block' }}
      >
        <path d={path} fill="#0b1020" />
      </svg>
    </span>
  );
}
